import {Component, Inject, Input, OnDestroy, OnInit, PLATFORM_ID, QueryList, ViewChildren} from '@angular/core';
import {isPlatformBrowser} from "@angular/common";
import {WINDOW} from "@biletix/core/common";
import {Clipboard} from "@angular/cdk/clipboard";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatMenuTrigger} from "@angular/material/menu";
import {Platform} from "@angular/cdk/platform";
import { LoadingScreenService } from '@biletix/core/components/loading/loading-screen.service';

export enum ShareType {

    FACEBOOK,
    WHATS_APP,
    TWITTER,
    TELEGRAM,
    MESSENGER,
    EMAIL,
    SMS,
    COPY_LINK,
    PRINT,
    LINKED_IN
}

export interface ShareParams {
    url?: string;
    title?: string;
    description?: string;
    image?: string;
    tags?: string;
}

export interface ShareButton {
    /** Share button type */
    type?: ShareType,
    /** Share button text */
    text: string;
    /** Share button aria label attribute */
    ariaLabel?: string;
    /** Share button icon (FontAwesome) */
    icon?: string | string[] | any;
    /** Share button color */
    color?: string;
    /** Sharer target used in opening the share window */
    target?: string;

    /** Sharer base URL */
    share?: {
        desktop?: string;
        android?: string;
        ios?: string;
    };
    /** Sharer URL params */
    params?: ShareParams;
    paramsFunc?: any,
    data?: any;

}


export const SHARE_BUTTONS: ShareButton[] = [
    // {
    //     type: ShareType.FACEBOOK,
    //     text: 'Facebook',
    //     ariaLabel: 'Share on Facebook',
    //     icon: 'facebook',
    //     color: '#4267B2',
    //     share: {
    //         desktop: 'https://www.facebook.com/sharer/sharer.php?'
    //     },
    //     params: {
    //         url: 'u'
    //     }
    // },

    // {
    //     type: ShareType.TWITTER,
    //     text: 'Twitter',
    //     ariaLabel: 'Share on Twitter',
    //     icon: ['fab', 'twitter'],
    //     color: '#00acee',
    //     share: {
    //         desktop: 'https://twitter.com/intent/tweet?'
    //     },
    //     params: {
    //         url: 'url',
    //         description: 'text',
    //         tags: 'hashtags',
    //         via: 'via'
    //     }
    // },
    // {
    //     type: ShareType.LINKED_IN,
    //     text: 'LinkedIn',
    //     ariaLabel: 'Share on LinkedIn',
    //     icon: ['fab', 'linkedin-in'],
    //     color: '#006fa6',
    //     share: {
    //         desktop: 'https://www.linkedin.com/shareArticle?'
    //     },
    //     params: {
    //         url: 'url',
    //         title: 'title',
    //         description: 'summary'
    //     }
    // },

    // {
    //     type: ShareType.TELEGRAM,
    //     text: 'Telegram',
    //     ariaLabel: 'Share on Telegram',
    //     icon: ['fab', 'telegram-plane'],
    //     color: '#0088cc',
    //     share: {
    //         desktop: 'https://t.me/share/url?'
    //     },
    //     params: {
    //         url: 'url',
    //         description: 'text'
    //     }
    // },
    {
        type: ShareType.MESSENGER,
        text: 'performance.labels.messenger',
        ariaLabel: 'Share on Messenger',
        icon: 'messenger',
        color: '#0080FF',
        share: {
            // desktop:  'fb-messenger://share/?',//TODO: Mesenger drsktop için çalışmayabilir.
            android: 'fb-messenger://share/?',
            ios: 'fb-messenger://share/?'
        },
        params: {
            url: 'link'
        }
    },
    {
        type: ShareType.WHATS_APP,
        text: 'performance.labels.whatsapp',
        ariaLabel: 'Share on WhatsApp',
        icon: 'whats_app',
        color: '#25D366',
        share: {
            desktop: 'https://web.whatsapp.com/send?',
            android: 'whatsapp://send?',
            ios: 'https://api.whatsapp.com/send?'
        },
        params: {
            description: 'text'
        }
    },

    // {
    //     type: ShareType.SMS,
    //     text: 'performance.labels.sms',
    //     ariaLabel: 'Share link via SMS',
    //     icon: 'sms',
    //     color: '#20c16c',
    //     share: {
    //         desktop: 'sms:?',
    //         ios: 'sms:&'
    //     },
    //     params: {
    //         description: 'body'
    //     },
    // },
    {
        type: ShareType.EMAIL,
        text: 'shared.labels.email',
        ariaLabel: 'Share link via email',
        icon: 'email',
        color: '#FF961C',
        share: {
            desktop: 'mailto:?',
            android: 'mailto:?',
            ios: 'mailto:?'
        },
        params: {
            title: 'subject',
            description: 'body'
        },
    },
    {
        type: ShareType.COPY_LINK,
        text: 'shared.labels.copyLink',
        ariaLabel: 'Copy link',
        icon: 'copy_link',
        color: '#607D8B',
        data: {
            text: 'Copy link',
            icon: ['fas', 'link'],
            successText: 'Copied',
            successIcon: ['fas', 'check'],
            delay: 2000
        }
    },

    // {
    //     type: ShareType.PRINT,
    //     text: 'Print',
    //     ariaLabel: 'Print page',
    //     icon: 'print',
    //     color: '#765AA2',
    // },
];


export interface ShareButtonsConfig {
    title?: string;
    description?: string;
    url?: string,
    image?: string
}


@Component({
    selector: 'btx-share-button',
    templateUrl: './share-button.component.html',
    styleUrls: ['./share-button.component.scss'],
  standalone: false
})
export class ShareButtonComponent implements OnInit, OnDestroy {

    /**
     * Masaustu ve mobil tetikleyici artik ikisi de hep DOM'da (gorunurluk CSS'te,
     * bkz. share-button.component.scss sonundaki not). Eskiden *ngIf masaustu
     * tetikleyicisini yok ediyordu ve MatMenuTrigger.ngOnDestroy -> destroyMenu()
     * acik menuyu kapatiyordu. Artik yok edilmedigi icin 960px sinirini menu
     * acikken gecince (tablet dondurme) overlay acik kaliyor, CDK backdrop'u
     * mobil fab'in ilk tiklamasini yutuyor ve tetikleyicide bayat
     * aria-expanded="true" kaliyor. Kirilim gecisinde acik menuyu elle kapatiyoruz.
     */
    @ViewChildren(MatMenuTrigger) private menuTriggers?: QueryList<MatMenuTrigger>;

    /** SCSS'teki @media (max-width: 959.98px) ile BIREBIR ayni olmali. */
    private static readonly MOBILE_MEDIA_QUERY = '(max-width: 959.98px)';

    private mobileMediaQueryList?: MediaQueryList;
    private readonly onBreakpointChange = (): void => {
        this.menuTriggers?.forEach((trigger: MatMenuTrigger) => trigger.closeMenu());
    };



    /** The title parameter */
    @Input() menuTitle?: string;


    /** The page URL */
    @Input() url?: string;
    @Input() title?: string;
    @Input() description?: string;

    /** The image parameter for sharing  */
    @Input() image?: string;

    /** The tags parameter for sharing on Twitter and Tumblr */
    @Input() tags?: string;


    /** Show button icon */
    @Input() showIcon = true;

    /** Show button text */
    @Input() showText = true;

    @Input() staticShare = true;


    shareLinkItems: ShareButton[] = SHARE_BUTTONS;
    shareButton: ShareButton | any;

    constructor(@Inject(WINDOW) private window: Window,
                @Inject(PLATFORM_ID) private platformId: Object,
                private snackBar: MatSnackBar,
                private platform: Platform,
                private clipboard: Clipboard,
                private loadingService:LoadingScreenService) {
    }

    ngOnInit(): void {
        const currentUrl = this.window?.location?.href;

        this.url = this.url ?? currentUrl;
        this.title = this.title ?? currentUrl;
        this.description = this.description ?? currentUrl;

        // SSR mock'unda matchMedia yok; platform kontrolu + optional call sart.
        if (isPlatformBrowser(this.platformId) && typeof this.window?.matchMedia === 'function') {
            this.mobileMediaQueryList = this.window.matchMedia(ShareButtonComponent.MOBILE_MEDIA_QUERY);
            this.mobileMediaQueryList.addEventListener('change', this.onBreakpointChange);
        }
    }

    ngOnDestroy(): void {
        this.mobileMediaQueryList?.removeEventListener('change', this.onBreakpointChange);
    }


    onClickShareLinkItem(shareButton: ShareButton) {
        this.shareButton = shareButton;
        this.loadingService.open();

          switch (shareButton?.type) {
            case ShareType.WHATS_APP:
                this.onClickWhatsApp();
                break;
            case ShareType.COPY_LINK:
                this.copyToClipboard();
                break;
            case ShareType.SMS:
                this.sendSms();
                break;
            case ShareType.EMAIL:
                this.sendMailTo();
                break;
            case ShareType.MESSENGER:
                this.onClickMessenger();
                break;
        }
        this.loadingService.close();

    }

    onClickWhatsApp() {
        const shareLink = this.getSharerLink(this.shareButton);
        if (shareLink) {
            let finalUrl = `${shareLink}${this.shareButton.params.description}=${this.url}`;
            this.openNewWindow(finalUrl);
        }
    }

    openNewWindow(url: string, target: string = '_blank') {
        window.open(
            url,
            target // <- This is what makes it open in a new window.
        );
    }

    onClickMessenger() {
        const shareLink = this.getSharerLink(this.shareButton);
        if (shareLink) {
            let finalUrl = `${shareLink}${this.shareButton.params?.url}=${this.url}`;
            this.openNewWindow(finalUrl);
        }
    }

    /**
     * mailto:phonenumber?subject=&body=
     */
    sendMailTo() {
        const shareLink = this.getSharerLink(this.shareButton);
        if (shareLink) {
            // let finalUrl = `${shareLink}${this.shareButton.params.title}=${this.title}&${this.shareButton.params.description}=${this.description}`;
            let finalUrl = `${shareLink}${this.shareButton.params.title}=${this.title}&${this.shareButton.params.description}=${this.url}`;
            this.openNewWindow(finalUrl);
        }
    }


    /**
     * sms:phonenumber?body=
     */
    sendSms() {
        const shareLink = this.getSharerLink(this.shareButton);
        if (shareLink) {
            let finalUrl = `${shareLink}${this.shareButton.params.description}=${this.description}`;
            this.openNewWindow(finalUrl);
        }
    }

    copyToClipboard() {
        this.clipboard.copy(this.url ? this.url : this.description ?? '');
        this.snackBar.open("Copied", '', {
                duration: 1000,
                horizontalPosition: "end",
                verticalPosition: "bottom"
            },
        );
    }


    private getSharerLink(shareButton: ShareButton | any): string | any {
        let sharerLink: string;
        if (this.platform.IOS && shareButton.share.ios) {
            sharerLink = shareButton.share.ios;
        } else if (this.platform.ANDROID && shareButton.share.android) {
            sharerLink = shareButton.share.android;
        } else {
            sharerLink = shareButton.share.desktop;
        }
        return sharerLink;
    }

    isLinkVisible(shareButton: ShareButton) {
        if (shareButton && !shareButton.share) {
            return true;
        }

        return (this.platform.IOS && shareButton.share?.ios)
            || (this.platform.ANDROID && shareButton.share?.android)
            || (this.platform.isBrowser && shareButton.share?.desktop);
    }

    printPage() {
        document.defaultView?.print();
    }

}
